import React, { useState, useCallback, useEffect } from "react";

import {
    Box,
    Button,
    Divider,
    TextField,
    Grid,
    Card,
    styled,
    Typography,
    IconButton,
    List,
    ListItem,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    ListItemText,
    FormHelperText,
    Chip
} from '@mui/material';

import { grey, red } from "@mui/material/colors";

import { useFormik } from 'formik';
import { checkValueExists } from "../../../../../../utils/dataSchema"
import CommonSectionHeader from "../../../../../../components/common/CommonSectionHeader"

import { useAppContextFeatures } from "../../../../../../context/AppContext"
import { useSystemPrompt } from "../../../../../../hooks/useSystemPrompt";
import { useTranslations } from "../../../../../../hooks/useTranslations";
import { useAuthAccess } from "../../../../../../hooks/useAuthAccess"

import {
    useProduct,
    initialProductValues,
    validationProductSchema,
    productInjectionProps,
    paymentTypes as productPaymentTypes
} from "../../../../hooks/model/useProduct";

import {
    itemInjectionProps,
    defaultUom
} from "../../../../hooks/model/useProductItem";

import {
    useWorker
} from "../../../../hooks/model/useWorker"

import { getInjectionDataType } from "../../../../utils/injectionSelection";

export const validationSchema = validationProductSchema

export const initialValues = {
    ...initialProductValues
}

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));


const StyledBox = styled(Box)(({ theme }) => ({
    padding: 1
}));

export default function UpdateProductMain({
    routeType,
    productId,
    handleOnSuccess = () => { }
}) {

    const { t } = useTranslations({ ns: ["_@products", "_prompt", "common", "_common"] })

    const { promptMessage } = useSystemPrompt();

    const { authData } = useAuthAccess(routeType)

    const { setSystemLoading } = useAppContextFeatures();

    const { listWorkers } = useWorker({ routeType })

    const { updateProduct, getProduct, resyncProduct, filterOperatorTypes } = useProduct({ routeType })

    const [savedData, setSavedData] = useState()
    const [dataWorkers, setDataWorkers] = useState([])

    const authDataUserId = `${authData?.profile?.user?.id}`
    const authDataUserDisplay = `${authData?.profile?.user?.username}`

    const loadData = async (id) => {

        setSystemLoading(true);

        try {

            let dataTypesArray = [`${getInjectionDataType('product')}`, `${getInjectionDataType('item')}`]

            const data = await getProduct({ id, dataTypesArray })

            let dataSource = data?.product ? data.product : {}
            let _dataItems = data?.items ? data.items : {}

            // console.log('dataSource', dataSource)
            // console.log('dataItems', _dataItems)

            let dataItems = _dataItems.map(i => {
                return {
                    code: i?.code,
                    description: i?.item_description,
                    remark: i?.item_remark,
                    uomId: i?.uom_id,
                    uomPrice: i?.uom_price,
                    length: i?.dimension_length,
                    height: i?.dimension_height,
                    width: i?.dimension_width,
                    weight: i?.net_weight,
                    cbm: i?.cbm,
                    qty: i[itemInjectionProps.packQty.retrieveKey],
                    handleQty: i[itemInjectionProps.handleQty.retrieveKey],
                    handleQtyPerPackage: i[itemInjectionProps.qtyPerPackage.retrieveKey],
                    totalValue: i[itemInjectionProps.totalValue.retrieveKey],
                    totalCbm: i[itemInjectionProps.totalCbm.retrieveKey],
                    totalWeight: i[itemInjectionProps.totalWeight.retrieveKey],
                }
            })

            let savedData = {
                ...initialProductValues,
                userId: dataSource[productInjectionProps.customerUserId.retrieveKey],
                userMarking: dataSource[productInjectionProps.customerMarking.retrieveKey],
                userBranchId: dataSource[productInjectionProps.customerBranchId.retrieveKey],

                supplierName: dataSource[productInjectionProps.supplierName.retrieveKey],
                supplierContact: dataSource[productInjectionProps.supplierContact.retrieveKey],
                courierTrackingNo: dataSource[productInjectionProps.courierTrackingNo.retrieveKey],
                paymentType: dataSource[productInjectionProps.paymentMethod.retrieveKey],
                prepaidDepositAmount: dataSource[productInjectionProps.prepayDepositFee.retrieveKey],
                prepaidTransportAmount: dataSource[productInjectionProps.prepayTransportFee.retrieveKey],
                signUserId: dataSource[productInjectionProps.signedByUserId.retrieveKey],
                signUserDisplay: dataSource[productInjectionProps.signedByUserDisplay.retrieveKey],
                remark: dataSource[productInjectionProps.remark.retrieveKey],
                supplierPurchaseNumber: dataSource[productInjectionProps.supplierPurchaseNumber.retrieveKey],
                purchaseNumber: dataSource[productInjectionProps.companyPurchaseNumber.retrieveKey],

                barcode: dataSource[productInjectionProps.barcode.retrieveKey],
                loadStatus: dataSource[productInjectionProps.loadStatus.retrieveKey],
                loadContainerId: dataSource[productInjectionProps.loadContainerId.retrieveKey],

                sourceProductRemId: dataSource[productInjectionProps.sourceProductRemId.retrieveKey],
                isSplit: dataSource[productInjectionProps.isSplit.retrieveKey],
                splitFromRemId: dataSource[productInjectionProps.splitFromRemId.retrieveKey],

                // optional
                productCode: dataSource?.product_code,

                items: dataItems
            }

            setSavedData(savedData)

            let locationId = dataSource[productInjectionProps.registerLocationId.retrieveKey]

            fetchWorkers({ locationId })

        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

        setSystemLoading(false)
        return false

    }

    const onSubmit = async (currentValues) => {

        // console.log('currentValues', currentValues)

        setSystemLoading(true)

        try {

            let sourceProductRemId = savedData?.sourceProductRemId

            if (!sourceProductRemId) {
                throw Error(`sourceProductRemId is Required`)
            }

            let payload = {
                productId,
                sourceProductRemId,
                product: {

                    // loadContainerDateTime: currentValues?.loadContainerDateTime,
                    userMarking: currentValues?.userMarking,
                    userBranchId: currentValues?.userBranchId,
                    userId: currentValues?.userId,

                    barcode: currentValues?.barcode,
                    loadStatus: currentValues?.loadStatus,
                    loadContainerId: currentValues?.loadContainerId,

                    registerLocationId: currentValues?.registerLocationId,
                    registerLocationDisplay: currentValues?.registerLocationDisplay,

                    supplierName: currentValues?.supplierName,
                    supplierContact: currentValues?.supplierContact,
                    courierTrackingNo: currentValues?.courierTrackingNo,
                    prepaidDepositAmount: currentValues?.prepaidDepositAmount,
                    prepaidTransportAmount: currentValues?.prepaidTransportAmount,
                    signUserId: currentValues?.signUserId,
                    signUserDisplay: currentValues?.signUserDisplay,
                    remark: currentValues?.remark,
                    paymentType: currentValues?.paymentType,
                    purchaseNumber: currentValues?.purchaseNumber,
                    supplierPurchaseNumber: currentValues?.supplierPurchaseNumber,
                },
                lastUpdateUserId: `${authDataUserId}`,
                lastUpdateUserDisplay: `${authDataUserDisplay}`,
            }

            let response = await updateProduct(payload)


            if (handleOnSuccess) {
                handleOnSuccess()
            }

            promptMessage(true, `${t("savedSuccess")}`)

            return true

        } catch (error) {

            promptMessage(false, `${error?.message}`)

        }

        setSystemLoading(false)

        return true

    }

    const fetchWorkers = async ({ locationId }) => {

        try {

            const props = {
                limit: -1,
                skip: 0,
                filterValue: [],
                sortInfo: {
                    id: 'username',
                    dir: ''
                }
            }

            const { data: _data } = await listWorkers({
                props
            })

            let data = []

            _data.forEach(i => {
                const exists = i?.locations.filter(i2 => i2.id === locationId)
                if (exists.length > 0) {
                    data.push(i)
                }
            })

            setDataWorkers(data)

        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }

    }

    const handleReSync = async () => {

        setSystemLoading(true)

        try {
            let a = await resyncProduct({ productId })
        } catch (error) {
            promptMessage(false, `${t("failedToReSync")} - ${error?.message}`)
        } finally {
            setSystemLoading(false)
        }

    }

    const formik = useFormik({
        initialValues: savedData,
        validationSchema,
        enableReinitialize: true,
        onSubmit
    });

    const { values, errors, touched, handleChange, setFieldValue } = formik;

    useEffect(() => {

        loadData(productId)

    }, [])

    const RenderForm = () => {

        if (!values) return <></>

        return (

            <form onSubmit={formik.handleSubmit}>

                <Box
                    sx={{
                        p: 2
                    }}
                >
                    <Grid container spacing={1}>

                        <Grid item xs={12} sm={12} md={2} alignSelf={"flex-start"}>

                            <CommonSectionHeader
                                title={t('product')}
                                subTitle={t('updateProductInformation')}
                            />

                            <Divider
                                sx={{
                                    my: 1
                                }}
                            />

                            {/* <Chip
                                variant="outlined"
                                color="primary"
                                label={values?.productCode}
                            /> */}

                            <Typography
                                sx={{
                                    fontSize: 12
                                }}
                            >
                                {`${t('code')} : ${values?.productCode}`}
                            </Typography>

                            <Typography
                                sx={{
                                    fontSize: 12
                                }}
                            >
                                {`${t('barcode')} : ${values?.barcode}`}
                            </Typography>

                            <Divider
                                sx={{
                                    my: 1
                                }}
                            />

                            <Typography
                                sx={{
                                    fontSize: 12,
                                    color: grey[500]
                                }}
                            >
                                {`sourceProductRemId : ${values?.sourceProductRemId}`}
                            </Typography>

                            <Typography
                                sx={{
                                    fontSize: 12,
                                    color: grey[500]
                                }}
                            >
                                {`isSplit : ${values?.isSplit}`}
                            </Typography>

                            <Typography
                                sx={{
                                    fontSize: 12,
                                    color: grey[500]
                                }}
                            >
                                {`splitFromRemId : ${values?.splitFromRemId}`}
                            </Typography>

                            <Divider
                                sx={{
                                    my: 1
                                }}
                            />

                            {/* { */}
                            <Button
                                fullWidth
                                type="button"
                                variant="contained"
                                color="warning"
                                onClick={handleReSync}
                            >
                                {t("ReSync")}
                            </Button>
                            {/* } */}

                        </Grid>

                        <Grid item xs={12} sm={12} md={10} alignSelf={"center"}>
                            <Grid container spacing={1}>

                                <Grid item xs={12} sm={12} md={12} alignSelf={"center"}>

                                    <Typography
                                        sx={{
                                            fontSize: 18
                                        }}
                                    >
                                        {`${t("customerMarkings")} : ${values?.userMarking}`}
                                    </Typography>

                                </Grid>

                                <Grid item xs={12} sm={12} md={4} alignSelf={"center"}>

                                    <TextField
                                        margin="dense"
                                        size="small"
                                        // autoFocus
                                        fullWidth
                                        name={`supplierName`}
                                        label={t('supplierName')}
                                        type="text"
                                        variant="outlined"
                                        value={values?.supplierName ? values.supplierName : ''}
                                        onChange={handleChange}
                                        error={Boolean(errors?.supplierName)}
                                        helperText={errors?.supplierName}
                                    />

                                </Grid>
                                <Grid item xs={12} sm={12} md={4} alignSelf={"center"}>

                                    <TextField
                                        margin="dense"
                                        size="small"
                                        // autoFocus
                                        fullWidth
                                        name={`supplierContact`}
                                        label={t('supplierContact')}
                                        type="text"
                                        variant="outlined"
                                        value={values?.supplierContact ? values.supplierContact : ""}
                                        onChange={handleChange}
                                        error={Boolean(errors?.supplierContact)}
                                        helperText={errors?.supplierContact}
                                    />

                                </Grid>
                                <Grid item xs={12} sm={12} md={4} alignSelf={"center"}>

                                    <TextField
                                        margin="dense"
                                        size="small"
                                        // autoFocus
                                        fullWidth
                                        name={`courierTrackingNo`}
                                        label={t('courierNo')}
                                        type="text"
                                        variant="outlined"
                                        value={values?.courierTrackingNo ? values.courierTrackingNo : ""}
                                        onChange={handleChange}
                                        error={Boolean(errors?.courierTrackingNo)}
                                        helperText={errors?.courierTrackingNo}
                                    />

                                </Grid>
                                <Grid item xs={12} sm={12} md={4} alignSelf={"center"}>

                                    <TextField
                                        margin="dense"
                                        size="small"
                                        // autoFocus
                                        fullWidth
                                        name={`prepaidDepositAmount`}
                                        label={t("payDeposit")}
                                        type="text"
                                        variant="outlined"
                                        value={values?.prepaidDepositAmount ? values.prepaidDepositAmount : ""}
                                        onChange={handleChange}
                                        error={Boolean(errors?.prepaidDepositAmount)}
                                        helperText={errors?.prepaidDepositAmount}
                                    />

                                </Grid>


                                <Grid item xs={12} sm={12} md={4} alignSelf={"center"}>

                                    <TextField
                                        margin="dense"
                                        size="small"
                                        // autoFocus
                                        fullWidth
                                        name={`prepaidTransportAmount`}
                                        label={t("payFreight")}
                                        type="text"
                                        variant="outlined"
                                        value={values?.prepaidTransportAmount ? values.prepaidTransportAmount : ""}
                                        onChange={handleChange}
                                        error={Boolean(errors?.prepaidTransportAmount)}
                                        helperText={errors?.prepaidTransportAmount}
                                    />

                                </Grid>

                                <Grid item xs={12} sm={12} md={4} alignSelf={"center"}>
                                    <FormControl
                                        margin="dense"
                                        fullWidth
                                        size="small"
                                        error={Boolean(errors?.signUserId)}
                                        disabled
                                    >
                                        <InputLabel id="signUserId">{t('signedBy')}</InputLabel>

                                        <Select
                                            labelId="signUserId"
                                            label={t('signedBy')}
                                            name={`signUserId`}
                                            onChange={(event) => {

                                                let userId = event.target.value

                                                // get user display
                                                let userInfo = dataWorkers.filter(i => i.user_id === userId)

                                                setFieldValue("signUserId", userId)
                                                setFieldValue(
                                                    "signUserDisplay",
                                                    userInfo.length ? `${userInfo[0]?.firstname}${userInfo[0]?.lastname} (${userInfo[0]?.username})` : ""
                                                )
                                            }}
                                            // value={values?.signUserId}
                                            value={
                                                checkValueExists({
                                                    dataSearch: dataWorkers,
                                                    searchFieldId: "user_id",
                                                    valueToCompare: values.signUserId
                                                })
                                            }
                                        >
                                            {
                                                dataWorkers?.map((i, index) => {
                                                    return (
                                                        <MenuItem
                                                            key={index}
                                                            value={i?.user_id}
                                                        >
                                                            {
                                                                `${i?.firstname}${i?.lastname} (${i?.username})`
                                                            }
                                                        </MenuItem>
                                                    )
                                                })
                                            }

                                        </Select>
                                        {/* <FormHelperText>
                                            {touched.signUserId && errors.signUserId}
                                        </FormHelperText> */}

                                    </FormControl>
                                </Grid>

                                {/* <Grid item xs={12} sm={12} md={4} alignSelf={"center"}>

                                    <TextField
                                        margin="dense"
                                        size="small"
                                        // autoFocus
                                        fullWidth
                                        name={`Barcode`}
                                        label="Barcode"
                                        type="text"
                                        variant="outlined"
                                        value={values?.barcode ? values.barcode : ""}
                                        onChange={handleChange}
                                        error={Boolean(errors?.barcode)}
                                        helperText={errors?.barcode}
                                    />

                                </Grid>

                                <Grid item xs={12} sm={12} md={4} alignSelf={"center"}><></></Grid>
                                <Grid item xs={12} sm={12} md={4} alignSelf={"center"}><></></Grid> */}

                                <Grid item xs={12} sm={12} md={4} alignSelf={"center"}>

                                    <FormControl
                                        margin="dense"
                                        fullWidth
                                        size="small"
                                        error={Boolean(errors?.paymentType)}
                                    >
                                        <InputLabel id="paymentType">{t('paymentType')}</InputLabel>
                                        <Select
                                            fullWidth
                                            size="small"
                                            // labelId="paymentType"
                                            name="paymentType"
                                            label={t('paymentType')}
                                            onChange={handleChange}
                                            value={values?.paymentType ? values.paymentType : ""}
                                        >
                                            {
                                                Object.keys(productPaymentTypes).map((i, index) => {
                                                    return (
                                                        <MenuItem
                                                            key={index}
                                                            value={productPaymentTypes[i].id}
                                                        >
                                                            <ListItemText primary={`${productPaymentTypes[i].display}`} />
                                                        </MenuItem>
                                                    )
                                                })
                                            }
                                        </Select>
                                        <FormHelperText>
                                            {errors?.paymentType}
                                        </FormHelperText>
                                    </FormControl>

                                </Grid>

                                <Grid item xs={12} sm={12} md={4} alignSelf={"center"}>

                                    <TextField
                                        margin="dense"
                                        size="small"
                                        // autoFocus
                                        fullWidth
                                        name={`purchaseNumber`}
                                        label={t('purchaseOrderNo')}
                                        type="text"
                                        variant="outlined"
                                        value={values?.purchaseNumber ? values.purchaseNumber : ""}
                                        onChange={handleChange}
                                        error={Boolean(errors?.purchaseNumber)}
                                        helperText={errors?.purchaseNumber}
                                    />

                                </Grid>

                                <Grid item xs={12} sm={12} md={4} alignSelf={"center"}>

                                    <TextField
                                        margin="dense"
                                        size="small"
                                        // autoFocus
                                        fullWidth
                                        name={`supplierPurchaseNumber`}
                                        label={t('supplierPurchaseNo')}
                                        type="text"
                                        variant="outlined"
                                        value={values?.supplierPurchaseNumber ? values.supplierPurchaseNumber : ""}
                                        onChange={handleChange}
                                        error={Boolean(errors?.supplierPurchaseNumber)}
                                        helperText={errors?.supplierPurchaseNumber}
                                    />

                                </Grid>



                                <Grid item xs={12} sm={12} md={12} alignSelf={"center"}>

                                    <TextField
                                        margin="dense"
                                        size="small"
                                        rows={3}
                                        multiline
                                        // autoFocus
                                        fullWidth
                                        name={`remark`}
                                        label={t('remark')}
                                        type="text"
                                        variant="outlined"
                                        value={values?.remark ? values.remark : ""}
                                        onChange={handleChange}
                                        error={Boolean(errors?.remark)}
                                        helperText={errors?.remark}
                                    />

                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>

                <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
                    <Grid item md={12} textAlign={"right"}>
                        {/* {
                            values?.loadStatus === productLoadStatusTypes.loaded.value ?
                                (
                                    <Typography
                                        sx={{
                                            color: red[500],
                                            fontSize: 14
                                        }}
                                    >
                                        Not allowed to change once loaded to container
                                    </Typography>
                                )
                                :
                                ( */}
                        <Button
                            type="submit"
                            // fullWidth
                            variant="contained"
                            sx={{
                                mt: 3,
                                mb: 2
                            }}
                        >
                            {t('saveChanges')}
                        </Button>
                        {/* )
                        } */}
                    </Grid>
                </Grid>
            </form >

        )
    }

    return (
        <Box>

            {/* {JSON.stringify(values)} */}
            {
                RenderForm()
            }

        </Box>
    )
}